export const buildURL = ({regionID}) => {
    const segments = location.pathname.split('/');

    segments[2] = regionID;

    return segments.join('/');
};
